import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { MANUAL_BOOKING_APPROVAL, MANUAL_BOOKING_APPROVAL_SUCCESS, MANUAL_BOOKING_APPROVAL_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* manualBookingApproval({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { approval_id } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/create-manual-booking`,
      method: 'POST',
      params: payload.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: MANUAL_BOOKING_APPROVAL_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: MANUAL_BOOKING_APPROVAL_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: MANUAL_BOOKING_APPROVAL_ERROR, payload: error });
  }
}

export function* watchManualBookingApproval() {
  yield takeEvery(MANUAL_BOOKING_APPROVAL, manualBookingApproval);
}

function* manualBookingApprovalSaga() {
  yield all([fork(watchManualBookingApproval)]);
}

export default manualBookingApprovalSaga;
